import { render } from "./DocumentUploadsFree.vue?vue&type=template&id=6099abba"
import script from "./DocumentUploadsFree.vue?vue&type=script&lang=js"
export * from "./DocumentUploadsFree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__